// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import colors from 'vuetify/lib/util/colors'

// Vuetify
import { createVuetify } from 'vuetify'
export default createVuetify({
  theme: {
    themes: {
      light: {          
        colors: {
          primary: "#01579B", 
          secondary: colors.grey.lighten3, 
          successColor: '#628b48',  
          warningColor: '#FFC43D',  
          errorColor: '#d74d45', 
          error: '#d74d45', 
        }
      },
    },
  },
})